export const TABLE_ROW_BG_ENABLED = '#FFFFFF';
export const TABLE_ROW_BG_DISABLED = '#F5F5F5';
export const TABLE_TEXT_DISABLED = '#85878F';
export const TABLE_TEXT_ACCENT = '#52659B';

export const isDisabledStatus = (status?: string) => status === 'DISABLED';

export const isInactiveVessel = (active?: boolean) => active === false;

export const getDisabledRowTextStyle = (status?: string) =>
  isDisabledStatus(status) ? { color: TABLE_TEXT_DISABLED } : {};

export const getInactiveVesselTextStyle = (active?: boolean) =>
  isInactiveVessel(active) ? { color: TABLE_TEXT_DISABLED } : {};

export const getDisabledStatusRowProps = <T extends { status?: string }>(row: { original: T }) => ({
  sx: {
    backgroundColor: isDisabledStatus(row.original.status)
      ? TABLE_ROW_BG_DISABLED
      : TABLE_ROW_BG_ENABLED
  }
});

export const getInactiveVesselRowProps = <T extends { active?: boolean }>(row: { original: T }) => ({
  sx: {
    backgroundColor: isInactiveVessel(row.original.active)
      ? TABLE_ROW_BG_DISABLED
      : TABLE_ROW_BG_ENABLED
  }
});
